<template>
  <span v-if="envConfig" data-testid="common-ui-env-tag" class="EnvTag" :class="`EnvTag--${envConfig.color}`">
    {{ envConfig.label }}
  </span>
</template>

<script setup lang="ts">
  const deployEnv = useRuntimeConfig().public.deploy.env;

  const envConfigs: Record<string, { label: string; color: 'blue' | 'yellow' }> = {
    dev: { label: 'DEVELOPMENT', color: 'blue' },
    staging: { label: 'STAGING', color: 'yellow' },
  };

  const envConfig = envConfigs[deployEnv];
</script>

<style scoped>
  @reference '~/assets/css/main.css';

  .EnvTag {
    @apply block min-w-0 shrink truncate rounded-sm px-2 py-1 text-xs font-medium tracking-wide text-black uppercase;
  }

  .EnvTag--yellow {
    @apply bg-yellow-400;
  }

  .EnvTag--blue {
    @apply bg-primary-2;
  }
</style>
